import ContactForm from "../components/Contact/ContactForm";
import ProfileLinks from "../components/Contact/ProfileLinks/ProfileLinks";

function Contact() {
  return (
    <div className="App">
      <main>
        <ContactForm />
        <ProfileLinks />
      </main>
    </div>
  );
}

export default Contact;
